<div class="main">
  <header-menu></header-menu>

  <div class="colab-manager-wrapper">
    <div class="content colab-manager-content no-padding">
      <div class="colab-manager-content-component fade-in-animation">

        <breadbrumbs [items]="breadcrumbItems" ></breadbrumbs>

        <h1>Meus convites</h1>

        <invites-list *ngIf="!(invitesLoading$ | async)" [invites]="invites$ |async"></invites-list>

        <overlay-loading *ngIf="invitesLoading$ | async"></overlay-loading>
      </div>
    </div>
  </div>

</div>
